<div class="modal-header">
  <h4 id="variant-selector-modal" class="modal-title">{{ "Select variant" | translate }}</h4>
  <button (click)="modal.dismiss()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <button
    *ngFor="let variant of variants"
    [class.disabled]="variant.frozenAsAmbiguous && !enableSelectFrozen"
    (click)="variantClicked($event, variant)"
    class="btn btn-outline-secondary variant"
  >
    <astrobin-equipment-item-display-name [item]="variant"></astrobin-equipment-item-display-name>
  </button>
</div>

<div class="modal-footer">
  <button (click)="modal.dismiss()" class="btn btn-outline-secondary" type="button">
    {{ "Cancel" | translate }}
  </button>
</div>
